import { CSSProperties, useState } from "react";
import styled from "@emotion/styled";
import { FxGuard } from "@coralblack/flax";
import { Footer } from "@layouts/Footer";
import { usePreScreeningSiteContext } from "@layouts/home/PreScreeningSiteContext";
import { Main } from "@layouts/Main";
import { useEcoaBreadcrumb } from "@hooks/useEcoaBreadcrumb";
import { ecoaConfigApi } from "maven-lib/dist/states/apis/ecoaConfig";
import { PreScreeningSiteSelection } from "../PreScreeningSiteSelection";
import ecoaLogo from "@maven-surface/assets/image/logo_maven_ecoa_text_blue.png";
import mavenLogo from "@maven-surface/assets/image/logo_maven_icon_circle_blue.png";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { ECOA_PRESCREENING_LANG } from "@maven-msg/lang/ecoa";
import { MvnMessage } from "@maven-msg/lib/Message";

interface PreScreeningCoverProps {
  studyId: bigint;
  onStart: () => void;
}

const StyledPreScreeningCoverTitleWrapper = styled.div`
  padding: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledPreScreeningCoverTitle = styled.img`
  width: 60%;
  padding-left: 1rem;
`;

const StyledPreScreeningCoverTitleLogo = styled.img`
  width: 15%;
`;

const StyledPreScreeningCoverTitleDescriptionWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

interface StyledPreScreeningCoverTitleDescriptionProps {
  isHighlighted: boolean;
  whiteSpace?: CSSProperties["whiteSpace"];
}

const StyledPreScreeningCoverTitleDescription = styled.span<StyledPreScreeningCoverTitleDescriptionProps>`
  ${({ isHighlighted }) => isHighlighted && `color: #259ac5;`}
  white-space: ${({ whiteSpace }) => whiteSpace};
  text-align: center;
  font-size: 1rem;
`;

export function PreScreeningCover(props: PreScreeningCoverProps) {
  const { studyId, onStart } = props;
  const { header, footer } = useEcoaBreadcrumb();

  const { studySites, selectedSite, setSelectedSite } = usePreScreeningSiteContext();

  const [siteSelectionVisibility, setSiteSelectionVisibility] = useState<boolean>(false);

  const buttonDesc = MvnMessage(COMMON_LANG.NEXT);

  return (
    <Main header={siteSelectionVisibility ? { appName: true } : header} footer={footer}>
      <FxGuard
        api={ecoaConfigApi.getEcoaConfig(studyId)}
        render={(resp) => {
          if (!resp?.config?.recruit) <></>;

          return (
            <>
              {!siteSelectionVisibility && (
                <>
                  <StyledPreScreeningCoverTitleWrapper>
                    <StyledPreScreeningCoverTitleLogo alt="" src={mavenLogo} />
                    <StyledPreScreeningCoverTitle alt={process.env.REACT_APP_NAME} src={ecoaLogo} />
                  </StyledPreScreeningCoverTitleWrapper>
                  {(() => {
                    const targetWord = `'${buttonDesc}'`;
                    const titleDesc = MvnMessage(ECOA_PRESCREENING_LANG.ECOA_PRESCREENING_COVER_TITLE_DESC, { buttonDesc });
                    const [titleDesc1, titleDesc2] = titleDesc.split(`${targetWord}`);

                    return (
                      <StyledPreScreeningCoverTitleDescriptionWrapper>
                        <StyledPreScreeningCoverTitleDescription isHighlighted={false} whiteSpace="nowrap">
                          {titleDesc1}
                        </StyledPreScreeningCoverTitleDescription>
                        <StyledPreScreeningCoverTitleDescription isHighlighted={true} whiteSpace="nowrap">
                          &nbsp;{`${targetWord}`}&nbsp;
                        </StyledPreScreeningCoverTitleDescription>
                        <StyledPreScreeningCoverTitleDescription isHighlighted={false} whiteSpace="nowrap">
                          {titleDesc2}
                        </StyledPreScreeningCoverTitleDescription>
                      </StyledPreScreeningCoverTitleDescriptionWrapper>
                    );
                  })()}
                  <Footer>
                    <HbButton
                      text={buttonDesc}
                      iconRight="ChromeBackMirrored"
                      onClick={() => {
                        if (selectedSite) {
                          onStart();
                        } else if (!selectedSite) {
                          setSiteSelectionVisibility(true);
                        }
                      }}
                    />
                  </Footer>
                </>
              )}
              {siteSelectionVisibility && (
                <PreScreeningSiteSelection
                  sites={studySites}
                  onSiteSelected={(selected) => {
                    setSelectedSite(selected);
                    onStart();
                  }}
                />
              )}
            </>
          );
        }}
      />
    </Main>
  );
}
